// components/Common/ExportButtonGroup.jsx
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import { Button, Snackbar, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { primaryButton } from "../../../styles/commonStyles";
import { exportAsCSV, exportAsPDF } from "../../../utils/exportUtils";

const ExportButtonGroup = ({ fileName, tableHeaders, tableRows, isDisabled }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const logoUrl = "/assets/logo/nutikorv.png";

  const getBase64 = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const logoBase64 = await getBase64(logoUrl);
      await exportAsPDF(theme, fileName, tableHeaders, tableRows, logoBase64);
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="contained" sx={primaryButton(theme)} onClick={handleExport} disabled={loading || isDisabled} startIcon={<PictureAsPdfIcon />}>
        {t("downloadPDF")}
      </Button>

      <Button variant="contained" sx={primaryButton(theme)} onClick={() => exportAsCSV(fileName, tableHeaders, tableRows)} startIcon={<TableChartIcon />} disabled={isDisabled}>
        {t("downloadCSV")}
      </Button>

      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)} message={t("exportSuccess")} />
    </>
  );
};

export default ExportButtonGroup;
